"use client";
import React, { Component } from "react";

class SplitText extends Component {
  render() {
    let gridText = this.props.text;
    let periods = gridText.match(/\./g, " ").length;
    let index1 = Math.round(periods / 3);
    let indices = [];

    for (var v = 0; v < gridText.length; v++) {
      if (gridText[v] == ".") {
        indices.push(v);
      }
    }

    let index11 = indices[index1];

    let index2 = index1 * 2;
    let index22 = indices[index2];

    let index3 = index1 * 3;
    let index33 = indices[index3];

    let index4 = index1 * 4;
    let index44 = indices[index4];

    let index5 = index1 * 5;
    let index55 = indices[index5];

    let str1 = this.props.text ? gridText.substring(0, index11 + 1) : "";
    let str2 = this.props.text ? gridText.substring(index11 + 1, index22) : "";
    let str3 = this.props.text ? gridText.substring(index22 + 1, index33) : "";
    let str4 = this.props.text ? gridText.substring(index33 + 1, index44) : "";
    let len = str1 + str2;
    let x = len.length;
    return (
      <div>
        <p>{str1}</p>
        <p>{str2}</p>
        <p>{str3}</p>
        {/*<p>{this.props.text}</p>*/}
        {/*{this.props.text ? this.props.text.substring(0, 100) : 'loading'}*/}
      </div>
    );
  }
}

export default SplitText;
